<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>{{ this.rxID }} - {{ this.rxName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="py-0">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting RX details.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="py-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-data-table
            :loading="load"
            :headers="headers"
            :items="rx_data"
            :search="search"
            :sort-by="'SERVICE_DATE'"
            :sort-desc="[true]"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, -1],
            }"
            :items-per-page="10"
            loading-text="Loading data..."
            class="elevation-0 col-md-12 m-auto pb-0"
          >
            <template v-slot:item.AMOUNT="{ item }"> ${{ formatCurrency(item.AMOUNT) }} </template>
          </v-data-table>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RxDetails',
  props: [
    'value',
    'insurance',
    'rxID',
    'rxName',
    'groups',
    'providers',
    'locations',
    'start',
    'end',
  ],
  data() {
    return {
      search: '',
      load: false,
      active: false,
      headers: [
        { text: 'Patient Name', value: 'MBR_NM' },
        { text: 'Date of Birth', value: 'MBR_DOB' },
        { text: 'Provider', value: 'PROV_NM' },
        { text: 'Last Fill', value: 'SERVICE_DATE' },
        { text: 'Cost', value: 'AMOUNT' },
      ],
      dialog: false,
      loading: true,
      requestError: false,
      rx_data: [],
    };
  },
  mounted() {
    this.openModal();
  },
  methods: {
    async openModal() {
      if (this.value == true && this.rxID != null && this.rxID != 0 && this.rxID != '') {
        this.getRx();
      }
    },
    async getRx() {
      this.load = true;
      this.requestError = false;
      this.rx_data = [];

      const provNums = this.providers;
      let providers = [];
      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      const locs = this.locations;
      let locations = [];
      if (locs.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }

      const url = `api/modal/rx/details/groups=${this.groups}/providers=${providers}/locs=${locations}/${this.insurance}/${this.rxID}/${this.start}/${this.end}`;
      axios
        .get(url)
        .then((response) => {
          this.rx_data = response.data.data;
          this.load = false;
        })
        .catch((error) => {
          this.requestError = true;
          this.load = false;
        });
    },
    formatCurrency(c) {
      if (c != undefined) return c.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async rxID() {
      if (this.rxID != null && this.rxID != 0 && this.rxID != '') {
        this.getRx();
      }
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
